import { Component, inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
  Command,
  CommandStore,
  SOFTLINE_FEATURE_COMMANDS,
  SOFTLINE_FEATURE_TITLE,
  TitleStore,
} from '@softline/application';
import { Store } from '@softline/core';
import { debounceTime } from 'rxjs/operators';
import {
  SOFTLINE_FEATURE_TIMESTAMP,
  SOFTLINE_FEATURE_TIMESTAMP_CURRENT_EMPLOYEE,
  TimestampStore,
} from '../stempelerfassung.shared';
import { UserInfoService } from '@softline/auth';
import { TimestampCurrentEmployeeStore } from '../store/current-employee.store';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { PageComponent } from '@softapps/core';
@Component({
  // tslint:disable-next-line:component-selector
  selector: 'soft-timestamp-app',
  templateUrl: './timestamp-app.component.html',
  styleUrls: ['./timestamp-app.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterModule, PageComponent],
})
export class TimestampAppComponent implements OnInit, OnDestroy {
  private store = inject(Store);
  private readonly userInfo = inject(UserInfoService);
  protected router = inject(Router);
  protected route = inject(ActivatedRoute);

  isLoading$ = this.store
    .observe(SOFTLINE_FEATURE_TIMESTAMP, TimestampStore.getters.loading)
    .pipe(debounceTime(400));

  constructor() {
    //
  }

  async ngOnInit(): Promise<void> {
    this.store.commit(
      SOFTLINE_FEATURE_TITLE,
      TitleStore.mutations.setTitle,
      '#TIMESTAMP.TITLE'
    );

    this.store.commit(SOFTLINE_FEATURE_COMMANDS, CommandStore.mutations.addSet, {
      name: TimestampAppComponent,
      commands: this.createCommands(),
    });

    const userId = this.userInfo.value()?.userId;
    await this.store.dispatch(
      SOFTLINE_FEATURE_TIMESTAMP_CURRENT_EMPLOYEE,
      TimestampCurrentEmployeeStore.actions.loadEmployee,
      { userId }
    );
  }

  ngOnDestroy(): void {
    this.store.commit(SOFTLINE_FEATURE_TITLE, TitleStore.mutations.setTitle, '');
    this.store.commit(SOFTLINE_FEATURE_TITLE, TitleStore.mutations.setSubTitle, '');
    this.store.commit(
      SOFTLINE_FEATURE_COMMANDS,
      CommandStore.mutations.removeSet,
      TimestampAppComponent
    );
  }

  protected createCommands(): Command[] {
    const commands: Command[] = [
      {
        icon: 'fa-regular fa-stopwatch',
        name: '#TIMESTAMP.TITLE',
        class: 'menu main-menu main-menu-top',
        routerLink: ['stempelerfassung'],
      },
      {
        icon: 'fa-regular fa-magnifying-glass',
        name: '#TIMESTAMP.QUERY',
        class: 'menu main-menu main-menu-top',
        routerLink: ['stempelerfassung', 'query'],
      },
    ];
    return commands;
  }
}
